import { Outlet, Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

export const ProtectedRoute = () => {
  const { accounts } = useMsal();
  const isAuthenticated = !!accounts.length;

  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};
